
import React from 'react';

interface AttendanceStatsProps {
  stats: {
    totalRecords: number;
    uniqueMembers: number;
    booksRead: number;
    dailyAverage: number;
  };
}

const AttendanceStats: React.FC<AttendanceStatsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div className="bg-blue-50 p-3 rounded-lg">
        <div className="text-2xl font-bold text-blue-600">{stats.totalRecords}</div>
        <div className="text-xs text-gray-600">Total Records</div>
      </div>
      <div className="bg-green-50 p-3 rounded-lg">
        <div className="text-2xl font-bold text-green-600">{stats.uniqueMembers}</div>
        <div className="text-xs text-gray-600">Unique Members</div>
      </div>
      <div className="bg-purple-50 p-3 rounded-lg">
        <div className="text-2xl font-bold text-purple-600">{stats.booksRead}</div>
        <div className="text-xs text-gray-600">Books Read</div>
      </div>
      <div className="bg-orange-50 p-3 rounded-lg">
        <div className="text-2xl font-bold text-orange-600">{stats.dailyAverage}</div>
        <div className="text-xs text-gray-600">Daily Average</div>
      </div>
    </div>
  );
};

export default AttendanceStats;